import { TimeEntryCategory } from "@myapp/contract";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const CATEGORY_LABELS: Record<TimeEntryCategory, string> = {
  SICK_LEAVE: "Krankheit",
  VACATION: "Urlaub",
  TRAINING: "Schulung",
  PERSONAL_LEAVE: "Privatzeit",
};

export const getTimeEntryCategoryLabel = (category: TimeEntryCategory): string =>
  CATEGORY_LABELS[category];

export const TIME_ENTRY_CATEGORY_COLOR = "#BBA6D9";

export const timeEntryCategoryOptions: ISelectOption[] = (
  Object.keys(CATEGORY_LABELS) as TimeEntryCategory[]
).map((category) => ({ value: category, label: CATEGORY_LABELS[category] }));
